<template>
  <div class="mx-auto">
    <v-btn
      color="info"
      icon
      class="float-right ma-8 btn--plain"
      @click="$emit('close:form')"
    >
      <v-icon>mdi-close</v-icon>
    </v-btn>

    <v-form
      ref="form"
      v-model="valid"
      style="width: 80%"
      class="pt-10 pb-4 mx-auto text-left"
    >
      <div class="custom-title py-8">
        Property Address
      </div>
      <div class="text-left">
        <div class="font-weight-medium secondary--text pb-2">
          Street Address
        </div>
        <v-text-field
          v-model="streetAddress"
          rounded
          solo
          flat
          dense
          background-color="#F0F5F6"
          class="pb-2"
          :rules="[(v) => !!v || 'Item is required']"
        />
        <div class="font-weight-medium secondary--text pb-2">
          Unit/Apt
        </div>
        <v-text-field
          v-model="unitNo"
          rounded
          solo
          flat
          dense
          background-color="#F0F5F6"
          class="pb-2"          
        />
        <div class="font-weight-medium secondary--text pb-2">
          City
        </div>
        <v-autocomplete
          v-model="city"
          :items="items"
          :loading="loading"
          :search-input.sync="search"
          hide-no-data
          hide-selected
          item-value="id"
          item-text="name"
          placeholder="Start typing to Search"
          return-object
          rounded
          solo
          flat
          dense
          background-color="#F0F5F6"
          class="pb-2"
          :rules="[(v) => !!v || 'Item is required']"
        >
          <template
            slot="selection"
            slot-scope="data"
          >
            {{ displayCityInfo(data.item) }}
          </template>
          <template
            slot="item"
            slot-scope="data"
          >
            {{ displayCityInfo(data.item) }}
          </template>
          <v-icon
            slot="append"
            medium
            color="accent"
          >
            mdi-chevron-down
          </v-icon>
        </v-autocomplete>

        <div class="font-weight-medium secondary--text pb-2">
          State
        </div>
        <v-text-field
          v-model="state"
          item-color="#F6F9FA"
          rounded
          solo
          flat
          dense
          disabled
          background-color="#F0F5F6"
          class="pb-2"
          :rules="[(v) => !!v || 'Item is required']"
        />

        <div class="font-weight-medium secondary--text pb-2">
          Zip Code
        </div>
        <v-text-field
          v-model="zipcode"
          rounded
          solo
          flat
          dense
          background-color="#F0F5F6"
          class="pb-2"
          :rules="[(v) => !!v || 'Item is required']"
        />

        <div class="font-weight-medium secondary--text pb-2">
          County
        </div>
        <v-select
          v-model="county"
          item-color="#F6F9FA"
          rounded
          item-text="countyName"
          item-value="countyName"
          solo
          flat
          dense
          background-color="#F0F5F6"
          :items="counties"
          class="pb-2"
          :rules="[(v) => !!v || 'Item is required']"
        >
          <v-icon
            slot="append"
            medium
            color="accent"
          >
            mdi-chevron-down
          </v-icon>
        </v-select>
      </div>
    </v-form>

    <v-card-actions
      style="background-color: #fafbfc; border-radius: 0px 0px 10px 10px"
      class="justify-end py-4 pr-12 mt-12"
    >
      <v-btn
        rounded
        color="accent_light"
        class="mb-2 mt-4 btn--plain capital--btn"
        text
        @click="back"
      >
        go back
      </v-btn>
      <v-btn
        rounded
        color="accent_light"
        class="px-8 mb-2 mt-4 white--text capital--btn"
        depressed
        :disabled="!valid"
        @click="next"
      >
        continue
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { states } from "@/resources/index.js";

export default {
  name: "PropertyAddress",
  data() {
    return {
      valid: false,
      streetAddress: this.currentProperty ? this.currentProperty.streetAddress : "",
      city: "",
      subdivision: this.currentProperty ? this.currentProperty.subdivision : "",
      state: this.currentProperty ? this.currentProperty.subdivision : "New Jersey",
      zipcode: this.currentProperty ? this.currentProperty.zipcode : "",
      county: this.currentProperty ? this.currentProperty.county : "",
      unitNo: this.currentProperty ? this.currentProperty.unitNo : "",
      states,
      counties: [],
      subdivisions: [],
      loading: false,
      allCitiesandSubs: [],
      items: [],
      search: null,
      select: null,
      useNext: false,
    };
  },
  computed: {
    ...mapGetters({
      currentProperty: "property/currentProperty",
      caseSteps: "eviction/caseSteps"
    }),
  },
  watch: {
    search(newVal) {
      if (newVal) {
        this.items = this.allCitiesandSubs
          .filter((c) => {
            let find = c.name.toLowerCase().startsWith(newVal.toLowerCase());
            return find;
          })
          .sort((a, b) => (a.name > b.name ? 1 : -1));
      }
    },
    city(val) {
      if (val && val.mileagePrice) {
        this.subdivisions = [];
        return;
      } else {
        if (val && val.id) {
          this.loading = true;

          this.$http
            .get(`${process.env.VUE_APP_URL}/subdivisionsOfCity`, {
              params: {
                cityId: val.id,
              },
            })
            .then((results) => results.data)
            .then((data) => {
              this.subdivisions = data;
              this.loading = false;
            })
            .catch((e) => {
              console.log(e);
              this.loading = false;
            });
        }
      }
    },
    currentProperty: {
      deep: true,
      immediate: true,
      handler: async function(value) {
        if (value?.propertyId) {
          // if (!this.items.length) {
          //   console.log('a')
          //   this.city = this.allCitiesandSubs.find(item => item.name === value.city)
          // } else {
          //   console.log('b')
          //   this.city = this.items.find(item => item.name === value.city);
          // }

          if (!this.allCitiesandSubs.length) {
            let result = await this.$http.get(`${process.env.VUE_APP_URL}/allCities`);
            this.allCitiesandSubs = result.data;
            this.items = result.data;
            this.$refs.form.resetValidation()
            this.$store.commit("set_all_cities_and_subs", result.data);
          }

          this.streetAddress = value.streetAddress;
          this.city = this.allCitiesandSubs.find(item => item.name === value.city);
          this.subdivision = value.subdivision;
          this.state = value.state;
          this.zipcode = value.zipcode;
          this.county = value.county;
          this.unitNo = value.unitNo;
        }
      },
    },
  },
  async activated() {
    this.useNext = false;
    window.scrollTo(0, 0);

    if (!this.allCitiesandSubs.length) {
      this.loading = true;

      try {
        let result = await this.$http.get(`${process.env.VUE_APP_URL}/allCities`);
        this.allCitiesandSubs = result.data;
        this.items = result.data;
        this.$refs.form.resetValidation()
        this.$store.commit("set_all_cities_and_subs", result.data);

        result = await this.$http.get(
          `${process.env.VUE_APP_URL}/countiesOfState`,
          {
            params: {
              stateId: 31,
            },
          }
        );
        this.counties = result.data;

        this.loading = false;
      } catch (e) {
        this.loading = false;
        console.log(e);
      }
    }
  },
  deactivated() {
    this.saveData();
  },
  methods: {
    saveData() {
      if (this.useNext) return;

      if (this.valid) {
        const propertyData = {
          streetAddress: this.streetAddress,
          city: this.$store.getters.isAuthenticated ? this.city : this.city.name,
          subdivision: this.subdivision,
          state: this.state,
          zipcode: this.zipcode,
          county: this.county,
          unitNo: this.unitNo,
          status: 'address'
        }
        if (this.$route.name.includes("vc")) {
          this.$store.dispatch("property/saveProperty", {
            propertyData,
          });
        }
      }
    },
    next() {
      this.useNext = true;
      this.valid = this.$refs.form.validate();
      if (this.valid) {
        
        let stepData = {};
        if (this.currentProperty.propertyType === "Residential") {
          stepData = {
            type: "completed",
            address: "completed",
            registration: "completed",
            owner: "",
            associationToOwner: "",
            contact: "",
          }
          //this.$emit("update:steps", );
        } else {
          stepData = {
            type: "completed",
            address: "completed",
            registration: "hidden",
            owner: "completed",
            associationToOwner: "",
            contact: "",
          }
        }

        const propertyData = {
          streetAddress: this.streetAddress,
          city: this.$store.getters.isAuthenticated ? this.city : this.city.name,
          subdivision: this.subdivision,
          state: this.state,
          zipcode: this.zipcode,
          county: this.county,
          unitNo: this.unitNo,
          status: 'address'
        }
        if (this.$route.name.includes("vc")) {
          this.$store.dispatch("property/saveProperty", {
            propertyData, steps: stepData
          });

          let a = this.caseSteps;
          a.property.showChildren = true;
          
          if (this.currentProperty.propertyType === "Residential") {
            a.property.children['registration'].status = "completed";
          }
          else {
            a.property.children['owner'].status = "completed";
            a.property.children['registration'].status = "hidden";
          }
          this.$store.commit("eviction/update_steps", a);
        } else {
          this.$emit("save:property",propertyData);
          this.$emit("update:steps", stepData);
        }
        // this.$emit('next')

        this.$router.push({
          name:
            this.currentProperty.propertyType === "Residential"
              ? `${
                this.$route.name.includes("vc") ? "vc-" : ""
              }property-registration`
              : `${this.$route.name.includes("vc") ? "vc-" : ""}property-owner`,
        });
      }
    },
    back() {
      // this.$emit("update:steps", {
      //   type: "completed",
      //   address: "",
      //   registration: "",
      //   owner: "",
      //   associationToOwner: "",
      //   contact: "",
      // });

      this.$router.push({
        name: `${this.$route.name.includes("vc") ? "vc-" : ""}property-type`,
      });
    },
    displayCityInfo(cityOrSub) {
      if (cityOrSub.countyId) return cityOrSub.name;
      let city = this.allCitiesandSubs.find((c) => {
        if (!c.countyId) {
          return false;
        }
        return c.id === cityOrSub.cityId;
      });
      return `${cityOrSub.name} (${city.name})`;
      //return "needs work"
    },
  },
};
</script>

<style></style>
